import createReactClass from 'create-react-class';

('use strict');

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JS Modules
import { builderDispatch } from '../_utils/ui';
import CartItemsChangeEvents from './cart-items-change-events';
import Currency from '../_utils/tools/currency';
import DeliveryOptions from './delivery-options';
import generateCopiesList from './generate-copies-list';
import OutOfStockWarning from './out-of-stock-warning';
import PrismProductAttribute from './prism-product-attribute';
import PrismProductCopyInProgressWarning from './prism-product-copy-in-progress-warning';
import PrismProductIncompleteWarning from './prism-product-incomplete-warning';
import PrismProductOutOfStockWarning from './prism-product-out-of-stock-warning';
import ProductDisabledOptionsMessage from '../_utils/product-disabled-options-message';
import Select from '../_utils/select-wrapper';
import WarningMessage from '../_utils/warning-message';
import WarningMessages from '../_utils/warning-messages';
import ConfirmationDialog from './confirmation-dialog';
import deliveryOptionsCalculator from '../_utils/_delivery-options/calculator';
import OrderContents from '../_utils/_order-data/order-contents';
import { Collapsible } from './collapsible';
import { EditLink } from './edit-link';
import { DeleteButton } from './delete-button';
import { CrossSellPanel } from './cross_sell_panel';

// -----------------------------------------------------------
//  PrismItem
// -----------------------------------------------------------
const PrismItem = createReactClass({
  getInitialState() {
    return {
      confirmDelete: false,
      isClient: false,
    };
  },

  displayName: 'PrismItem',

  componentDidMount() {
    this.setState({ isClient: true });
  },

  render() {
    const {
      id,
      disabled,
      quantity,
      delivery,
      edit_url: editUrl,
      product_title: productTitle,
      delivery_options: deliveryOptions,
      cross_sell: crossSellItem,
    } = this.props;
    const { loggedIn, showDeliveryOptionSelectorsWithinItems } = this.context;
    const quantityOptions = generateCopiesList(this.props.set_copies).map(
      (c) => {
        return { value: c.toString(), label: c.toString() };
      },
    );
    const isPrismProduct = editUrl != '#';
    const prismProductTitle = productTitle || '';
    const quantitySelectBaseId = `quantity-select-${id}-`;
    const hasMultipleDeliveryOptions = deliveryOptions.length > 1;
    const showDeliveryOptionForm =
      hasMultipleDeliveryOptions && showDeliveryOptionSelectorsWithinItems;

    return (
      <div>
        {this.state.isClient && this.renderWarning()}
        {this.state.isClient && this.props.outOfStock && (
          <PrismProductOutOfStockWarning />
        )}
        {showDeliveryOptionForm && (
          <div className="row mb-2">
            <div className="col px-0">
              <Collapsible
                id={`delivery-options-${id}`}
                buttonText="Switch Delivery Option"
                expandedButtonText="Close"
                buttonClassName="btn-link text-decoration-none"
                headerClassName="text-right">
                <DeliveryOptions
                  options={deliveryOptions}
                  selectedOption={delivery}
                  itemId={id}
                />
              </Collapsible>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-8 col-sm-2">
            <img src={this.props.thumbnail} className="img-fluid" />
          </div>
          <div className="col-4 d-sm-none d-flex flex-column justify-content-between">
            <h4 className="price text-right">
              <span className="sr-only">Price: </span>
              {Currency.format(this.props.cost)}
            </h4>
            <div className="form-group">
              <label className="sr-only" htmlFor={`${quantitySelectBaseId}-1`}>
                Quantity
              </label>
              <Select
                id={`${quantitySelectBaseId}-1`}
                options={quantityOptions}
                value={quantity}
                onChange={this.handleQuantityChange}
                className="rounded-pill"
              />
            </div>
          </div>
          <div className="d-sm-none clearfix" />
          <div className="col-12 col-sm-10">
            <div className="row">
              <div className="col-12 col-sm-7">
                <h5 className="text-truncate">
                  <strong>{this.props.title}</strong>
                </h5>
                <div className="product-title">{prismProductTitle}</div>
                <ul className="list-inline attributes text-muted">
                  {this.renderAttributes()}
                </ul>
              </div>
              <div className="d-none d-sm-block col-sm-5">
                <div>
                  <ul className="list-inline">
                    <li className="price-container list-inline-item float-right">
                      <h4 className="price text-right">
                        <span className="sr-only">Price: </span>
                        {Currency.format(this.props.cost)}
                      </h4>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="text-right">
              {!!(isPrismProduct && !disabled) && (
                <EditLink label={`Edit ${prismProductTitle}`} url={editUrl} />
              )}
              <DeleteButton
                className="prism-item__remove-btn"
                onClick={this.openConfirmationDialog}
                text="Remove"
                label={`Delete ${prismProductTitle}`}
              />
              {!!(isPrismProduct && loggedIn && this.state.isClient) && (
                <button
                  className="btn btn-link text-decoration-underline prism-item__save-for-later-btn"
                  aria-label={`Save ${prismProductTitle} for later`}
                  onClick={() => this.handleDelete(true)}>
                  <i
                    className="fas fa-cloud-upload-alt mr-1"
                    aria-hidden="true"></i>
                  Save for later
                </button>
              )}
              <div className="d-none d-sm-inline-block">
                <label
                  className="sr-only"
                  htmlFor={`${quantitySelectBaseId}-2`}>
                  Quantity
                </label>
                <Select
                  id={`${quantitySelectBaseId}-2`}
                  options={quantityOptions}
                  value={quantity}
                  onChange={this.handleQuantityChange}
                  className="rounded-pill"
                />
              </div>
            </div>
            {this.renderConfirmationDialog()}
          </div>
        </div>
        {crossSellItem && <CrossSellPanel item={crossSellItem} />}
      </div>
    );
  },

  renderAttributes() {
    const $attributes = [];

    for (let key in this.props.attributes) {
      $attributes.push(
        <PrismProductAttribute
          key={key}
          type={key}
          value={this.props.attributes[key][0].title}
        />,
      );
    }

    return $attributes;
  },

  renderWarning() {
    const {
      disabled,
      disabled_theme: disabledTheme,
      missing_attributes: missingAttributes,
      disabled_options_chosen: disabledOptions,
      copy_in_progress: copyInProgress,
      incomplete,
      alternatePickupStore,
    } = this.props;

    const itemUnavailableFromSelectedStore =
      this.isItemUnavailableFromSelectedStore();

    if (disabled) {
      return (
        <WarningMessage
          className="bleed-warning"
          dataTestId="disabled-item-error">
          {WarningMessages.disabledProduct}
          <br />
          Checkout is not available for this reason.
        </WarningMessage>
      );
    }

    if (disabledTheme) {
      return (
        <WarningMessage
          className="bleed-warning"
          dataTestId="disabled-theme-error">
          {WarningMessages.disabledTheme}
          <br />
          Checkout is not available for this reason.
        </WarningMessage>
      );
    }

    if (itemUnavailableFromSelectedStore) {
      return (
        <OutOfStockWarning
          alternateStore={alternatePickupStore}
          setStoreToAlternate={this.setStoreToAlternate}
          productMessage={itemUnavailableFromSelectedStore.message.full}
        />
      );
    }

    if (missingAttributes) {
      return (
        <WarningMessage
          className="bleed-warning"
          isWarning
          dataTestId="missing-attributes-error">
          {WarningMessages.missingAttributes}
          <br />
          Checkout is not available for this reason.
        </WarningMessage>
      );
    }

    if (disabledOptions) {
      return (
        <ProductDisabledOptionsMessage
          disabledOptions={disabledOptions}
          className="alert alert-danger"
          dataTestId="disabled-options-error">
          Checkout is not available for this reason.
        </ProductDisabledOptionsMessage>
      );
    }

    if (copyInProgress) {
      return (
        <PrismProductCopyInProgressWarning className="alert alert-warning">
          Checkout is not available for this reason.
        </PrismProductCopyInProgressWarning>
      );
    }

    if (incomplete) {
      return <PrismProductIncompleteWarning />;
    }
  },

  renderConfirmationDialog() {
    const { confirmDelete } = this.state;

    if (confirmDelete) {
      return (
        <ConfirmationDialog
          isOpen={this.state.confirmDelete}
          title="Confirm Project Deletion"
          confirmationText="Delete project"
          dialogText={
            'Are you sure you want to permanently delete this project?'
          }
          shouldShowDialog={confirmDelete}
          onConfirm={this.handleDelete}
          onClose={this.handleDialogClose}
        />
      );
    }
  },

  handleQuantityChange(value) {
    const { id, prism_id } = this.props;

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.QUANTITY_CHANGE,
      item: {
        id,
        prism_id,
      },
      value: value,
    });
  },

  handleDelete(soft = false) {
    const { id, prism_id } = this.props;

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.REMOVE_PRISM,
      item: {
        id,
        prism_id,
      },
      soft,
    });
  },

  openConfirmationDialog() {
    this.setState({
      confirmDelete: true,
    });
  },

  handleDialogClose() {
    this.setState({
      confirmDelete: false,
    });
  },

  chosenDeliveryOption() {
    return OrderContents.selectedDeliveryOption(this.props);
  },

  isItemUnavailableFromSelectedStore() {
    const { unavailableItems, selectedLocation } = this.context;

    if (
      !this.chosenDeliveryOption() ||
      deliveryOptionsCalculator.isShipping(this.chosenDeliveryOption())
    ) {
      return null;
    }

    return unavailableItems.find(
      (item) =>
        item.prismId === this.props.id && item.storeId === selectedLocation,
    );
  },

  setStoreToAlternate() {
    const alternateStore = this.props.alternatePickupStore || {},
      { id: storeId } = alternateStore;

    if (!storeId) {
      return;
    }

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.PICKUP_LOCATION_CHANGE,
      value: storeId,
    });
  },
});

PrismItem.contextTypes = {
  loggedIn: PropTypes.bool,
  showDeliveryOptionSelectorsWithinItems: PropTypes.bool,
  selectedLocation: PropTypes.string,
  unavailableItems: PropTypes.array,
};

export default PrismItem;
